module.exports = __webpack_public_path__ + "img/fournisseurEdition.4a84b170.png";